import React, { useEffect, useState } from 'react';
import { galleryAPI, ServiceType } from '../../services/galleryApi';
import toast from 'react-hot-toast';

interface TypeSelectorProps {
  selectedTypeId: string | null;
  onSelectType: (typeId: string) => void;
  allowEmpty?: boolean; // Option to allow an empty/default selection
}

const TypeSelector: React.FC<TypeSelectorProps> = ({ selectedTypeId, onSelectType, allowEmpty = false }) => {
  const [serviceTypes, setServiceTypes] = useState<ServiceType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchServiceTypes = async () => {
      try {
        setLoading(true);
        const types = await galleryAPI.getServiceTypes();
        setServiceTypes(types);
      } catch (err) {
        console.error('Failed to fetch service types:', err);
        setError('Failed to load service types.');
        toast.error('Erreur lors du chargement des types de service.');
      } finally {
        setLoading(false);
      }
    };

    fetchServiceTypes();
  }, []);

  if (loading) {
    return <select className="select select-bordered w-full" disabled><option>Chargement des types...</option></select>;
  }

  if (error) {
    return <div className="text-error">{error}</div>;
  }

  return (
    <select
      className="select select-bordered w-full"
      value={selectedTypeId || ''}
      onChange={(e) => onSelectType(e.target.value)}
    >
      {allowEmpty && <option value="">Sélectionner un type</option>}
      {serviceTypes.map((type) => (
        <option key={type._id} value={type._id}>
          {type.name}
        </option>
      ))}
    </select>
  );
};

export default TypeSelector;
